export class Zone {
  constructor(config) {
    this.name = config.name
    this.displayName = config.displayName
    this.bounds = config.bounds
    this.spawnPoint = config.spawnPoint
    this.terrainType = config.terrainType
    this.enemyTypes = config.enemyTypes || []
    this.enemyCount = config.enemyCount || 0
    this.chestCount = config.chestCount || 0
    this.isBossZone = config.isBossZone || false
    this.game = null // Set by EnemyManager
  }
  
  containsPoint(x, y) {
    return x >= this.bounds.minX && x <= this.bounds.maxX &&
           y >= this.bounds.minY && y <= this.bounds.maxY
  }
  
  getRandomPosition() {
    const radius = 0.4

    // Try to find a valid floor position (not wall, not void/AIR)
    for (let attempts = 0; attempts < 200; attempts++) {
      const x = this.bounds.minX + 2 + Math.random() * (this.bounds.maxX - this.bounds.minX - 4)
      const y = this.bounds.minY + 2 + Math.random() * (this.bounds.maxY - this.bounds.minY - 4)

      if (!this.game || !this.game.world) continue

      // Don't spawn in spawn safe zone
      if (this.game.world.isInSpawnSafeZone(x, y)) continue
      if (this.game.world.isEnemySpawnBlocked(x, y)) continue

      // Must be on a real floor tile (not solid, not AIR/void)
      const tile = this.game.world.getTileAt(Math.floor(x), Math.floor(y))
      if (tile === 0) continue // AIR = void, skip
      if (this.collidesAt(x, y, radius)) continue

      return { x, y }
    }

    // Fallback: deterministic scan for any valid floor tile.
    for (let y = this.bounds.minY + 1; y < this.bounds.maxY; y++) {
      for (let x = this.bounds.minX + 1; x < this.bounds.maxX; x++) {
        const px = x + 0.5
        const py = y + 0.5
        const tile = this.game?.world?.getTileAt(x, y)
        if (tile === 0) continue
        if (this.collidesAt(px, py, radius)) continue
        if (this.game.world.isInSpawnSafeZone(px, py)) continue
        if (this.game.world.isEnemySpawnBlocked(px, py)) continue
        return { x: px, y: py }
      }
    }

    return { ...this.spawnPoint }
  }

  collidesAt(x, y, radius) {
    return this.game.world.isSolid(x - radius, y - radius) ||
      this.game.world.isSolid(x + radius, y - radius) ||
      this.game.world.isSolid(x - radius, y + radius) ||
      this.game.world.isSolid(x + radius, y + radius)
  }
  
  getCenter() {
    return {
      x: (this.bounds.minX + this.bounds.maxX) / 2,
      y: (this.bounds.minY + this.bounds.maxY) / 2
    }
  }
}
